import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from '../../../auth/user.service';
import { AdminService } from '../../admin.service';
import { NotificationMessageService } from '../../../shared/notification-message/notification-message.service';
import { BreadcrumbService } from '../../../shared/breadcrumb/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-chargers',
	templateUrl: './chargers.component.html',
	styleUrls: ['./chargers.component.css']
})
export class ChargersComponent implements OnInit, OnDestroy {

	owners = {
		customerid: 0,
		siteid: 0
	}

	dealerId: 0;
	pageName: string;
	dealers = <any>[];

	devices = <any>[];
	selectedDevices = [];
	selectAllDevices: boolean;

	constructor(
		private adminService: AdminService,
		public userService: UserService,
		private route: ActivatedRoute,
		private router: Router,
		private notificationMessage: NotificationMessageService,
		private breadcrumb: BreadcrumbService,
		private translateService: TranslateService
	) {
	}

	ngOnInit() {
		this.selectAllDevices = false;
		this.pageName = this.route.snapshot.data['pageName'];

		let breadcrumbArr = [];

		if(this.pageName == 'listing') {
			this.route.params.subscribe( params => {
				this.owners.customerid = params['customerId'];
				this.owners.siteid = params['siteId'];

				breadcrumbArr = [
					{'label': this.translateService.instant('g.customers'), 'url': '/customers'},
					{'label': this.translateService.instant('g.sites'), 'url': '/sites/customerId/'+this.owners.customerid},
					{'label': this.translateService.instant('g.chargers'), 'url': ''}
				];

				this.getChargers();
			});
		} else {

			let label = this.translateService.instant('g.unassigned_chargers')
			if(this.pageName == 'unassignedSite')
				label = this.translateService.instant('g.unassigned_site_chargers')
			
			breadcrumbArr = [{'label': label, 'url': ''}];

			this.route.queryParams.subscribe( params => {
				this.dealerId = params['dealerId'] || 0;
				this.getNotAssignedChargers();
			});

			this.getDealers();
		}

		this.breadcrumb.setBreadcrumb(breadcrumbArr);
	}

	changeDealer() {
		this.router.navigate(
			['.'],
			{relativeTo: this.route, queryParams: {dealerId: this.dealerId}}
		);
	}

	getDealers(id = 0) {
		let noDealer = {'id':0, 'name': this.translateService.instant('g.no_dealer_dash')};
		this.adminService.getDealers(id).subscribe(
			data => {
				let dealers = data['dealers'] || [];
				dealers.unshift(noDealer);
				this.dealers = dealers;
			}
		);
	}

	getNotAssignedChargers() {
		let data = {
			'dealerid': this.dealerId,
			'isUnassignedSite': this.pageName == 'unassignedSite'
		};
		
		this.adminService.getNotAssignedChargers(data).subscribe(
			data => {
				this.devices = data;
				this.selectedDevices = [];
			}
		);
	}

	getChargers() {
		this.adminService.getChargers(this.owners).subscribe(
			data => {
				this.devices = data['list'];
				this.selectedDevices = [];
			}
		);
	}

	selectAllToggle(selectAllDevices) {
		let devices = [];
		let deviceIDs = [];
		let checked = selectAllDevices == true;
		
		for(let item of this.devices) {
			item.checked = checked;
			devices.push(item);
			if(checked)
				deviceIDs.push(Number(item.id));
		}
		
		this.devices = devices;
		this.selectedDevices = deviceIDs;
	};

	deleteCharger(id) {
		if(confirm(this.translateService.instant('g.del_charger_prompt'))) {
			this.adminService.deleteDevice(id, 'charger').subscribe(
				data => {
					this.getChargers();
				}
			);
		}
	};

	editChargerBtn(id, customerid, siteid) {
		this.router.navigate(
			['/chargers', 'edit', 'customerId', customerid, 'siteId', siteid],
			{queryParams: {'chargerId': id}}
		);
	}

	toggleDeviceSelection(checked, device) {
		
		device.checked = checked;
		
		if(checked) {
			this.selectedDevices.push(device.id);
			return
		}

		let idx = this.selectedDevices.indexOf(device.id);
		if(idx != -1)
			this.selectedDevices.splice(idx, 1);
	}

	goToEditDevicePurchaseOrder() {
		this.router.navigate(['/devices', 'devices-purchase-order-management', 'charger', this.selectedDevices.join(',')]);
	}

	autoCorrectCharger(ids) {
		this.adminService.autoCorrentDevices(this.owners.siteid, 'chargers', ids).subscribe(res=> {
			this.notificationMessage.setMessage(this.translateService.instant('device.auto_correct_msg') , 'success', 10000, true);
		});
	}

	ngOnDestroy() {
		this.breadcrumb.hide();
	}
}
